module.exports = __webpack_public_path__ + "static/media/ic_insta_fund_redemption.dc4f4b06.svg";